import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ServiceLeadForm } from '@/components/ServiceLeadForm';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Wrench, ExternalLink, ArrowRight } from 'lucide-react';

export const HandyManPage = () => {
  const questions = [
    { id: 'type_travaux', label: 'Type de travaux ?', type: 'select', options: ['Petite réparation', 'Fixation / Perçage', 'Plomberie légère', 'Électricité légère', 'Peinture retouche', 'Autre'] },
    { id: 'description', label: 'Décrivez brièvement le besoin', type: 'text', placeholder: 'Ex: Fixer 3 étagères, réparer une poignée de porte...' },
    { id: 'urgence', label: 'Urgence ?', type: 'select', options: ['Très urgent (24h)', 'Sous 48h', 'Cette semaine', 'Flexible'] },
    { id: 'recurrence', label: 'Besoin récurrent ?', type: 'select', options: ['Ponctuel', 'Mensuel', 'Contrat entretien'] }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <section className="py-20" style={{ backgroundColor: 'var(--sage)', color: 'white' }}>
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <Wrench className="h-10 w-10" />
            <Badge className="bg-white/20 text-white border-white/30">Homely Montage</Badge>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            Handy Man : petites réparations et entretien
          </h1>
          <p className="text-lg text-white/90 mb-8 max-w-2xl">
            Une poignée cassée, un tableau à fixer, un joint à refaire ? Nos équipes Handy Man interviennent rapidement pour tous vos petits travaux du quotidien.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="btn-premium h-14 px-10 rounded-full"
              onClick={() => document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}
            >
              Demander une intervention
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="h-14 px-8 rounded-full bg-white/10 border-white/30 text-white hover:bg-white hover:text-[var(--anthracite)] gap-2"
              onClick={() => window.open('https://www.homely-montage.ch', '_blank')}
            >
              <ExternalLink className="h-4 w-4" />
              homely-montage.ch
            </Button>
          </div>
        </div>
      </section>

      <section className="py-16 gradient-premium">
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>Nos interventions Handy Man</h2>
            <div className="section-divider"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {['Fixations murales', 'Réparation serrures', 'Joints salle de bain', 'Changement robinet', 'Interrupteurs / Prises', 'Retouches peinture', 'Portes qui grincent', 'Stores / Rideaux', 'Petite menuiserie'].map((s, i) => (
              <div key={i} className="card-premium p-4 text-center">
                <h3 className="font-semibold text-sm">{s}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16" style={{ backgroundColor: 'var(--anthracite)' }} id="form">
        <div className="mx-auto w-full max-w-2xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <ServiceLeadForm service="montage" pole="handyman" questions={questions} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
